import { useState, useEffect, Children } from "react";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";


const PlainButton = ({ children, url, 
  button_color='bright-accent',
  button_border='bright-accent',
  button_text
}) => {

  const [buttonSize, setButtonSize] = useState('');
  
  const isMobile = useMediaQuery({ maxWidth: 551 });
  const isTablet = useMediaQuery({ minWidth: 551, maxWidth: 801 });
  const isDesktop = useMediaQuery({ minWidth: 802 });

  useEffect(() => {
    if (isMobile) {
      setButtonSize('btn-sm');
    }
    
    if (isTablet) {
      setButtonSize('');
    }
    
    if (isDesktop) {
      setButtonSize('');
    }
  }, [isMobile, isTablet, isDesktop]);


  return (

    <>
    
      <Link to={url} className={`btn ${buttonSize} btn-${button_color} text-${button_text} font-custom`}>{children}</Link>
    
    </>

  );
}


export default PlainButton;